import * as Yup from "yup";

const today = new Date();
today.setHours(0, 0, 0, 0);

export const InitialValidationSchema = Yup.object({
  preliminary_info: Yup.object({
    person_of_contact: Yup.array()
      .of(
        Yup.object().shape({
          first_name: Yup.string().required('First name is required'),
          last_name: Yup.string().required('Last name is required'),
          email: Yup.string()
            .email('Invalid email format')
            .required('Email address is required')
            .test('unique-email', 'Email already exists', function (value) {
              if (!value) return true;
              const siblings = this.options.context?.person_of_contact || [];
              const indexes = [];
              siblings.forEach((contact, idx) => {
                if (contact.email === value) indexes.push(idx);
              });
              const currentIndex = this.path.split('[')[1].split(']')[0];
              return indexes.length <= 1 || 
                      currentIndex !== Math.max(...indexes).toString();
            })
        })
      )
      .min(1, 'At least one contact person is required'),
    project_info: Yup.object({
      business_unit: Yup.string()
        .nullable()
        .required("Business unit is required"),
      objective_of_project: Yup.string(),
      project_description: Yup.string().required("Description is required"),
      project_name: Yup.string().required("Project name is required"),
      tower: Yup.string().nullable().required("Tower is required"),
      type_of_work: Yup.string()
        .nullable()
        .required("Type of work is required"),
      type_of_services: Yup.string()
        .nullable()
        .required("Type of Services is required"),
    }),
    additional_info: Yup.string().notRequired(),
    deadlines: Yup.object({
      intention_participation_deadline: Yup.date()
        .nullable()
        .typeError("Invalid Date")
        .required("This is a required field")
        .min(today, "Date should be greater than or equal to today"),
      proposal_submission_deadline: Yup.date()
        .nullable()
        .required("This is a required field")
        .typeError("Invalid Date")
        .min(
          Yup.ref("intention_participation_deadline"),
          "Submission date must be greater than Participate date"
        )
        .test(
          "is-greater",
          "End date must be strictly greater than Participate date",
          function (value) {
            const { intention_participation_deadline } = this.parent; // Access other fields in the same object
            return value >= intention_participation_deadline; // Ensure submission_dt is strictly greater
          }
        ),
      time_zone: Yup.string().nullable().required("Time Zone is required"),
    }),

    //   rfp_terms_conditions: Yup.object()
    //     .shape({
    //       pre_agreed: Yup.boolean(),
    //       not_pre_agreed: Yup.boolean(),
    //     })
    //     .test(
    //       "at-least-one",
    //       "At least one checkbox must be selected",
    //       function (value) {
    //         return value.pre_agreed || value.not_pre_agreed;
    //       }
    //     ),
    // }),

  //   rfp_terms_conditions: Yup.object()
  //     .shape({
  //       pre_agreed: Yup.boolean(),
  //       not_pre_agreed: Yup.object({
  //         value: Yup.boolean(),
  //         external_terms_condition: Yup.boolean(),
  //         talent_tender_terms: Yup.boolean(),
  //         invite_vendors_terms: Yup.boolean(),
  //       }).test(
  //         "conditional-selection",
  //         "Select at least one option if 'Not Pre-Agreed' is chosen",
  //         function (notPreAgreed) {
  //           if (notPreAgreed?.value) {
  //             return (
  //               notPreAgreed.external_terms_condition ||
  //               notPreAgreed.talent_tender_terms ||
  //               notPreAgreed.invite_vendors_terms
  //             );
  //           }
  //           return true;
  //         }
  //       ),
  //     })
  //     .test(
  //       "at-least-one",
  //       "At least one checkbox must be selected",
  //       function (value) {
  //         return value?.pre_agreed || value?.not_pre_agreed?.value;
  //       }
  //     ),
  }),

  scope_of_work: Yup.object({
    requirement: Yup.array().min(
      1,
      "Scope of work must include at least one valid entry"
    ),
  }),
  bidders_selection: Yup.object({
    accredited_vendors: Yup.array().min(1),
  }),
});

export const DraftInitialSchema = Yup.object({
  preliminary_info: Yup.object({
    project_info: Yup.object({
      project_name: Yup.string().required("Project name is required"),
    }),
  }),
});
